import { useFormatHours } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { VariantsEnum } from '@ds/components/Tag/Tag.constant'

import {
  STATUS,
  STATUS_COLOR_VARIANT,
  STATUS_TRANSLATIONS,
} from '../constants/Status.constants'

import translations from './Status.translations'

export function useStatus() {
  const i18n = useI18n()
  const statusOptions = [
    { label: i18n(translations.new), value: STATUS.CREATED },
    { label: i18n(translations.pending), value: STATUS.PENDING },
    { label: i18n(translations.toSend), value: STATUS.TO_SEND },
    { label: i18n(translations.sent), value: STATUS.SENT },
    { label: i18n(translations.received), value: STATUS.RECEIVED },
    {
      label: i18n(translations.counterProposal),
      value: STATUS.COUNTER_OFFER,
    },
    { label: i18n(translations.validated), value: STATUS.VALIDATED },
    { label: i18n(translations.canceled), value: STATUS.CANCELLED },
    { label: i18n(translations.paid), value: STATUS.PAID },
    {
      label: i18n(translations.moneyTransfered),
      value: STATUS.MONEY_TRANSFERRED,
    },
    { label: i18n(translations.suspended), value: STATUS.SUSPENDED },
  ]

  const suspendReasonOptions = [
    {
      label: i18n(translations.customerAccountPresent),
      value: 'customer_account_present',
    },
    {
      label: i18n(translations.saleVoucherMissing),
      value: 'sale_voucher_missing',
    },
    {
      label: i18n(translations.deviceLocked),
      value: 'device_locked',
    },
    { label: i18n(translations.idMissing), value: 'id_missing' },
    {
      label: i18n(translations.productNonEuropean),
      value: 'product_non_european',
    },
    {
      label: i18n(translations.productBlacklisted),
      value: 'product_blacklisted',
    },
    {
      label: i18n(translations.productGreylisted),
      value: 'product_greylisted',
    },
    {
      label: i18n(translations.productRooted),
      value: 'product_rooted',
    },
    {
      label: i18n(translations.productCounterfeit),
      value: 'product_counterfeit',
    },
    {
      label: i18n(translations.parcelDamaged),
      value: 'parcel_damaged',
    },
    { label: i18n(translations.parcelEmpty), value: 'parcel_empty' },
    {
      label: i18n(translations.parcelNotReceived),
      value: 'parcel_not_received',
    },
  ]

  const statusTranslation = (status: string) => {
    const label = STATUS_TRANSLATIONS[status]

    return label ? i18n(label) : ''
  }

  const delay = (remainingHours: number) => {
    const { getFormatHoursInDay } = useFormatHours()
    if (remainingHours < 0) {
      return i18n(translations.delayExpired, {
        time: getFormatHoursInDay(Math.abs(remainingHours)),
      })
    }

    return getFormatHoursInDay(remainingHours)
  }

  const tag = (status: string) => {
    return {
      label: statusTranslation(status),
      variant: STATUS_COLOR_VARIANT[status] || VariantsEnum.Primary,
    }
  }

  return {
    statusOptions,
    suspendReasonOptions,
    statusTranslation,
    delay,
    tag,
  }
}
